/* Error.tsx generated by @compiled/babel-plugin v3.0.2 */
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports -- exports share Compiled style value(s) [styles] which cannot be exported across files (UI Styling Standard: no-exported-css) */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2fwxA5DIqT%7Btext-align%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r2NHnM%7Bpadding-top%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ZnuxbNHnM%7Bpadding-right%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wydGWNHnM%7Bpadding-bottom%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Zuz6QNHnM%7Bpadding-left%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3138422ADO%7Bmargin-top%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzKGUX%7Bcolor%3Avar(--ds-text-subtlest%2C%236b6e76)%7D");
import React from 'react';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Text } from '@atlaskit/primitives/compiled/text';
const styles = {
  errorWrapper: "_2fwxA5DIqT _0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM",
  errorTitle: "_3138422ADO",
  teamErrorText: "_1UtDYzKGUX _3138422ADO"
};
export const ErrorWrapper = (props: {
  children: React.ReactNode;
  testId?: string;
}): React.JSX.Element => <Box xcss={cx(styles.errorWrapper)} {...props} />;
export const ErrorTitle = (props: {
  children: React.ReactNode;
}): React.JSX.Element => <Box xcss={styles.errorTitle}>
		<Text color="color.text">{props.children}</Text>
	</Box>;
export const TeamErrorText = (props: {
  children: React.ReactNode;
}): React.JSX.Element => <Box xcss={cx(styles.teamErrorText)}>{props.children}</Box>;